<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 正式课 -->
    <div class="curriculum">
      <div class="curriculum-div">
        <h3>全部课程</h3>
       <!-- <div class="curriculum-div_hot">
          <img src="@/assets/hot.png" alt="美课教育" class="curriculum-div_hotImg" />
          <span class="curriculum-div_hotSpan">公告：</span>
          <div class="curriculum-div_hotRight">
            "带你了解"
            <span class="curriculum-div_hotRightSpan" @click="about()">美课教育</span>
          </div>
          <img src="@/assets/toright.png" alt="美课教育" class="curriculum-div_hotRightIng" />
        </div> -->
      </div>
      <!--tab切换-->
      <el-tabs v-model="tabActiveName" type="border-card" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in category" :key="index" :label="item.name" :name="item.id + ''">
          <div class="kecheng">
            <div class="kecheng-box">
              <div class="kecheng_box_item" v-for="(item2, index2) in courseData" :key="index2"
                @click="toDetails(item2.id)">
                <!-- <router-link to="/curriculumDetail"> -->
                <div class="imgK">
                  <img :src="item2.thumb" class="kecheng_box_item_img">
                </div>
                <div class="kecheng_box_item_title">
                  <h4>{{ item2.name }}</h4>
                </div>
                <div class="price">¥ {{item2.discount_price}}<b>原价：{{item2.original_price}}</b></div>
                <!-- </router-link> -->
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="pagefooter">
      <el-pagination background layout="prev, pager, next" prev-text="上一页" next-text="下一页" :total="total" :page-size="8"
        @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
      </el-pagination>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'curriculum',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        // Tab切换顶部数据定义数组
        category: [{
          id: 0,
          name: '全部'
        }],
        // Tab切换内容部分数据数组
        courseData: [],
        tabActiveName: 0,
        total: 0,
        currentPage: 1,
      }
    },

    created() {
      this.getInfo(0)
      this.getCategory()
    },
    methods: {
      getInfo(category) {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            category: category,
            type: '1,2,3',
            limit: 8,
            page: this.currentPage
          }
        }).then(res => {
          this.courseData = res.data.data.data
          this.total = res.data.data.total
        }).catch(err => {
          console.log(err)
        })
      },
      getCategory() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/category', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          }
        }).then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            this.category.push(res.data.data[i])
          }
        }).catch(err => {
          console.log(err)
        })
      },
      about() {
        this.$router.push({
          path: '/about'
        })
      },
      toDetails(id) {
        this.$router.push({
          path: "/curriculumDetail",
          query: {
            id: id
          }
        })
      },
      // tabs标签页切换事件
      handleClick(e) {
        this.currentPage = 1
        this.tabActiveName = e._props.name
        this.courseData = [];
        this.getInfo(e._props.name)
      },
      currentChange(e) {
        this.currentPage = e
        this.getInfo(this.tabActiveName)
      },
      prevClick(e) {
        this.currentPage = e
        this.getInfo(this.tabActiveName)
      },
      nextClick(e) {
        this.currentPage = e
        this.getInfo(this.tabActiveName)
      },
    }
  }
</script>
<style lang="scss" scoped>
  .pagefooter {
    display: inline-block;
    width: 100%;
    text-align: center;
    margin: 30px 0;
    margin-bottom: 50px;

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #FABE00;
      border: none;
      color: #fff;
    }

    /deep/ .el-pager li {
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #eaeaea;

      &:hover {
        color: #3dc57c;
      }
    }

    /deep/ .btn-prev {
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #eaeaea;
      padding: 0 10px;
    }

    /deep/ .btn-next {
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #eaeaea;
      padding: 0 10px;
    }
  }

  /deep/ .curriculum .el-tabs--border-card>.el-tabs__header {
    border-radius: 10px !important;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /deep/ .el-tabs__content {
    padding: 0;
  }

  /deep/ .is-focus {
    border: none;
  }

  .imgK {
    height: 180px;
    overflow: hidden;
  }

  .curriculum {
    padding: 0px;
    margin: 0px;
    width: 1200px;
    margin: 0 auto;
  }

  .curriculum-div {
    padding: 69px 0px 50px 0;
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0px auto;
    align-items: center;
  }

  .curriculum-div h3 {
    height: 45px;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #18252c;
    line-height: 45px;
  }

  .curriculum-div_hot {
    border-radius: 22px;
    border: 1px solid rgb(226, 226, 226);
    display: flex;
    height: 48px;
    align-items: center;
    padding: 0px 20px;
    box-sizing: border-box;
  }

  .curriculum-div_hotImg {
    width: 25px;
    height: 21px;
  }

  .curriculum-div_hotRightIng {
    width: 16px;
    height: 17px;
    margin-top: 2px;
    padding-right: 20px;
  }

  .curriculum-div_hotSpan {
    font-size: 16px;
    color: rgb(51, 51, 51);
    margin-left: 10px;
  }

  .curriculum-div_hotRight {
    color: rgb(51, 51, 51);
    font-size: 16px;
    padding-left: 18px;
    padding-right: 26px;
  }

  .curriculum-div_hotRightSpan {
    color: rgb(15, 111, 237);
    cursor: pointer;
  }

  .kecheng {
    width: 1200px;
    background-color: rgb(255, 255, 255);
    padding: 0px;
    margin: 0px auto;
  }

  .kecheng-box {
    display: flex;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
  }

  .kecheng_box_item {
    border-radius: 10px;
    background-color: #ffffff;
    padding: 8px;
    box-sizing: border-box;
    margin: 0 7px 30px 0;
    width: 292px;
    cursor: pointer;
  }

  .kecheng_box_item a {
    text-decoration: none;
  }

  .kecheng_box_item_img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }

  .kecheng_box_item_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    line-height: 40px;
    margin: 5px 0 5px 0;
    font-size: 19px;
  }

  .price {
    color: #ff7c06;
    text-align: left;
    font-size: 21px;
    font-weight: bold;
  }

  .price i {
    font-size: 14px;
    font-style: normal;
    color: #535353;
    margin-right: 5px;
  }

  .price b {
    color: #535353;

    font-size: 14px;
    text-decoration: line-through;
    margin-left: 10px;
  }

  .kecheng_box_item_title span:first-child {
    color: rgb(51, 51, 51);
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .kecheng_box_item_title span:last-child {
    min-width: 60px;
    height: 26px;
    background: #fffbf7;
    border: 1px solid #ffd4a7;
    border-radius: 10px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ff7c06;
    line-height: 26px;
    text-align: center;
    padding: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Curriculum.vue